import { IntegrationModel } from 'src/app/models/api';
import { StatusCodeEnum, StatusReasonEnum } from 'src/app/models/api/integration.model';

export const integrationIsNotFailing = (integration: IntegrationModel) =>
  integration.connectionStatus.code === StatusCodeEnum.on ||
  (integration.connectionStatus.code === StatusCodeEnum.off &&
    integration.connectionStatus.reason === StatusReasonEnum.deactivated);

export const integrationIsFailing = (integration: IntegrationModel) =>
  integration.connectionStatus?.code === StatusCodeEnum.off &&
  integration.connectionStatus?.reason === StatusReasonEnum.failing;
